import { useEffect, useState } from "react";
import { getRequest } from "../components/apiRequests/requestApi";
import CustomSvg from "../components/svgs/CustomSvg";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";

const getStatus = (tournament) => {
  if (tournament.hasEnded) return { label: "Ended", color: "border-red-600" };
  if (tournament.hasStarted) return { label: "Running", color: "border-green-600" };
  return { label: "Upcoming", color: "border-yellow-500" };
};

const formatDate = (dateString) =>
  new Date(dateString).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

const MyTournaments = () => {
  const [myTournaments, setMyTournaments] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTournaments = async () => {
      try {
        const response = await getRequest("/celebrity/tournaments");
        if (response && response.data) {
          setMyTournaments(response.data);
        } else {
          // console.error("No tournaments found or invalid response format.");
        }
      } catch (error) {
        // console.error("Error fetching tournaments:", error);
      }
    };
    fetchTournaments();
  }, []);

  return (
    <div className="min-h-screen bg-[#130828] px-6 text-white">
      {/* Header */}
      <div className="relative flex items-center justify-center py-5">
        <div className="absolute -left-1">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-white"
          >
            <CustomSvg name="arrow-left" width={20} height={20} color="#fff" />
            <AiOutlineArrowLeft size={24} />
          </button>
        </div>
        <h2 className="text-xl font-bold text-center">
          My{" "}
          <span className="bg-gradient-to-r from-[#C6BCFF] to-[#3F9217] bg-clip-text text-transparent">
            Tournaments
          </span>
        </h2>
      </div>

      <p className="text-base font-medium font-poppins mb-8">
        Here's a list of all competitions you’ve created.
      </p>

      {/* Tournaments */}
      {myTournaments.length === 0 ? (
        <p className="text-center text-gray-400">No tournaments created yet.</p>
      ) : (
        <div className="space-y-6">
          {myTournaments.map((tournament) => {
            const status = getStatus(tournament);
            return (
              <div
                key={tournament._id}
                className="border-b border-white/20 pb-4 flex items-center justify-between"
              >
                {/* Left Side */}
                <div className="space-y-1">
                  <h3 className="text-lg font-bold capitalize">
                    {tournament.name}
                  </h3>
                  <p className="text-sm font-poppins">
                    Players:{" "}
                    <span className="text-[#3F9217] font-semibold">
                      {tournament.participants.length}
                    </span>
                  </p>
                  <p className="text-sm font-poppins">
                    Gate Fee:{" "}
                    <span className="text-[#3F9217] font-semibold">
                      {tournament.hasGateFee
                        ? "₦" + (tournament.gateFee ?? 0)/100
                        : "Free"}
                    </span>
                  </p>
                  <p className="text-sm font-poppins">
                    Winners:{" "}
                    <span className="text-white/80">{tournament.noOfWinners}</span>
                  </p>
                  <p className="text-sm font-poppins">
                    Starts:{" "}
                    <span className="text-white/80">
                      {formatDate(tournament.startDate)}
                    </span>
                  </p>
                  <p className="text-sm font-poppins">
                    Register by:{" "}
                    <span className="text-white/80">
                      {formatDate(tournament.registrationDeadline)}
                    </span>
                  </p>
                  <p className=" text-[#3F9217] text-sm"><Link to={`/celebrity/${tournament._id}/leaderboard`}>View Tournament Leaderboard</Link></p>
                </div>

                {/* Status Badge */}
                <span
                  className={`text-sm font-semibold text-white px-3 py-2 rounded-xl border ${status.color}`}
                >
                  {status.label}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MyTournaments;
